import { createApi } from "@reduxjs/toolkit/query/react";
import { tomService } from "./restService";

/**
 * @Description
 * AI Suggestion & Insights API
 */

export const aiSuggestionApi = createApi({
  reducerPath: "aiSuggestionApi",
  baseQuery: tomService({
    baseUrl: `${process.env.REACT_APP_BASE_URL}/ai/company`,
  }),
  tagTypes: ["AISuggestions", "AIInsights"],

  endpoints: builder => ({
    /**
     * @Services - AI Insights
     */

    fetchAISuggestionMessages: builder.query({
      query: ({ company_id, offer_id }) => ({
        url: `/${company_id}/offer/${offer_id}/insights`,
        method: "GET",
      }),
      providesTags: ["AIInsights"],
    }),

    /**
     * @Services - AI Suggestion Parameters
     * Dynamic params accepted (e.g. { compa_ratio: 0.7, market_ratio: 1 })
     * and invalidates AI insights after completion
     */
 sendAISuggestionParams: builder.mutation({
  query: ({ company_id, offer_id, params = {} }) => {
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, v]) => v !== null && v !== undefined)
    );

    const query = new URLSearchParams(filteredParams).toString();

    return {
      url: `/${company_id}/offer/${offer_id}/compa-ratio-review${query ? `?${query}` : ""}`,
      method: "GET",
    };
  },
}),


  }),
});

export const {
  useFetchAISuggestionMessagesQuery,
  useSendAISuggestionParamsMutation,
} = aiSuggestionApi;
